import { running } from 'animejs';
import 'jquery-datepicker';
import 'jquery-datepicker/i18n/jquery.ui.datepicker-ja';

import 'jquery-format/src/jquery.format';
export default class CustomFunctions {
  /**
   * 初期化
   * @param options
   */
  constructor(options) {
    this.options = $.extend(options);
    this.init();
  }

  /**
   * 実行する
   */
  init() {
    this.infiniteSlider();
    this.cancelForms();
    this.calenderPicker();
    this.cancelDivide();
    this.presenceCheker();
    this.yearForm();
    this.documentForm();
    this.infoButtonChaker();
  }

  /**
   * カスタム関数
   */

  // ループスライダー
  infiniteSlider() {
    const optionInfinite = {
      infinite: true,
      arrows: false,
      swipe: false,
      dots: false,
      variableWidth: true,  // スライド幅の自動計算を無効
      autoplay: true,
      autoplaySpeed: 0,
      speed: 5000,
      cssEase: "linear",
      pauseOnFocus: false,
      pauseOnHover: false
    }
    const slickInfinite = $('.js-infinite-slider');
    if (slickInfinite) $(slickInfinite).slick(optionInfinite);
  }

  // 解約申請フォーム　/ cancellation-form
  cancelForms() {
    let $cancelBox = $('.js-cancel-check');
    let $formContainer =$('.js-form-container');
    if ($cancelBox.length <= 0) {
      return false;
    }

    $cancelBox.on('click', function () {
      $(this).toggleClass('is-active');
      $formContainer.toggleClass('is-active');
    })




  }

  calenderPicker() {
    let $calenderItem = $('.js-calender-picker');
    let $carenderCancel = $('.js-cancel-days-select');
    let $carenderPresence = $('.js-calender-picker.js-presence');
    if ($calenderItem.length <= 0) {
      return false;
    }
    var $holiday = ['/12/28','/12/29','/12/30','/12/31','/01/01','/01/02','/01/03','/01/04','/01/05']
    
    $.datepicker.regional['ja'] = {
      currentText: '今日',
      monthNames: ['1月','2月','3月','4月','5月','6月',
        '7月','8月','9月','10月','11月','12月'],
      monthNamesShort: ['1月','2月','3月','4月','5月','6月',
        '7月','8月','9月','10月','11月','12月'],
      dayNames: ['日曜日','月曜日','火曜日','水曜日','木曜日','金曜日','土曜日'],
      dayNamesShort: ['日','月','火','水','木','金','土'],
      dayNamesMin: ['日','月','火','水','木','金','土'],
      weekHeader: '週',
      dateFormat: 'yy/mm/dd',
      firstDay: 0,
      isRTL: false,
      showMonthAfterYear: true,
      beforeShowDay: function(day){
        var dtDay = $.format.date( day, "/MM/dd" );
        if( $.inArray( dtDay, $holiday ) != -1 ){
          return [false, 'ui-state-disabled'];
        } else {
          return [true, ''];
        }
      },
    };
    $.datepicker.setDefaults( $.datepicker.regional[ "ja" ] );

    $carenderCancel.datepicker({
      minDate: '+1m',
    });
    $carenderPresence.datepicker({
      minDate: '+8d'
    });
  }


  cancelDivide() {
    let $targetPersonal = $('.js-cancel-cheker.is-personal');
    let $targetCorporat = $('.js-cancel-cheker.is-corporat');
    let $itemPersonal = $('.c-block-forms__item.is-personal');
    let $itemCorporat = $('.c-block-forms__item.is-corporat');

    if ($targetPersonal.length <= 0 || $itemCorporat.length <= 0 || $itemPersonal.length <= 0 || $itemCorporat.length <= 0) {
      return false;
    }
    window.onpageshow = function(){
      $itemPersonal.addClass('is-active');
    }

    $targetPersonal.change(function () {
        $itemPersonal.addClass('is-active');
        $itemCorporat.removeClass('is-active');
    });

    $targetCorporat.change(function () {
        $itemCorporat.addClass('is-active');
        $itemPersonal.removeClass('is-active');
    });
  }

  yearForm() {
    let $target = $('.js-year-select');
    if ($target.length <= 0) {
      return false;
    }

    // 18歳以上　100歳以下の選択肢
    let $now = new Date();
    let $y = $now.getFullYear();
    let $startYear = $y - 18;
    let $lastyear = 100;
    let $select = $target.find('select');
    var $number;

    for (let i = 0; i < $lastyear; i++) {
      $number = $startYear - i;
      let $option = $('<option name="生年月日"></option>')
      $option.text($number);
      $select.append($option);
    }
  }

  presenceCheker() {
    let $targetFirst = $('.js-presence.is-first');
    let $targetSecond = $('.js-presence.is-second');
    let $cancelItem= $('.js-cancel-days-select');


    $cancelItem.change(function() {
      let $dateFrom = new Date($cancelItem.val());
      let $targetFirstValue = new Date($targetFirst.val());
      let $targetSecondValue = new Date($targetSecond.val());

      if ($targetFirst.val() !== '') {
        if ($dateFrom.getTime() <= $targetFirstValue.getTime()) {
          $targetFirst.parent().parent('span').addClass('is-error');
        } else {
          $targetFirst.parent().parent('span').removeClass('is-error')
        }
      }

      if ($targetSecond.val() !== '') {
        if ($dateFrom.getTime() <= $targetSecondValue.getTime()) {
          $targetSecond.parent().parent('span').addClass('is-error')
        } else {
          $targetSecond.parent().parent('span').removeClass('is-error')
        }
      }
    });

    $targetFirst.change(function() {
      if ($cancelItem.val() == '') {
        return false;
      }
      let $dateFrom = new Date($cancelItem.val());
      let $targetFirstValue = new Date($targetFirst.val());
      if ($dateFrom.getTime() <= $targetFirstValue.getTime()) {
        $(this).parent().parent('span').addClass('is-error')
      } else {
        $(this).parent().parent('span').removeClass('is-error')
      }
    });

    $targetSecond.change(function() {
      if ($cancelItem.val() == '') {
        return false;
      }
      let $dateFrom = new Date($cancelItem.val());
      let $targetSecondValue = new Date($targetSecond.val());
      if ($dateFrom.getTime() <= $targetSecondValue.getTime()) {
        $(this).parent().parent('span').addClass('is-error')
      } else {
        $(this).parent().parent('span').removeClass('is-error')
      }
    });
  }

  // sample() {

  // }

  documentForm() {
    let $target = $('.js-document-selector');
    let $checkItem = $target.find('input.is-checkbox');


    $checkItem.change(function() {
      let $textForm = $(this).parent().parent('.js-document-selector').find('label.is-document-number').find('input');
      if ( $(this).is(':checked')) {
        $textForm.prop('disabled', false);
      } else {
        $textForm.prop('disabled',true);
        $textForm.val('');
      }
    })
  }

  infoButtonChaker() {
    let $list = $('.js-info-buttons');
    let $target = $list.find($('.js-info-buttons-target'));

    if ($list.length <= 0 || $target.length <= 0) {
      return false;
    }

    if ($target.length < 5) {
      $list.addClass('is-center');
    }
  }

}




